import {i as p, a as g} from '@theme/card-image';
const a = 'model',
  o = 'item',
  v = 'product-card',
  k = '.card__media img[data-model-image]';
function n(d) {
  return d === o ? o : a;
}
class E extends HTMLElement {
  constructor() {
    super(),
      (this.view = a),
      (this.onButtonClick = this.onButtonClick.bind(this)),
      (this.onTrackClick = this.onTrackClick.bind(this)),
      (this.onGridRendered = this.onGridRendered.bind(this));
  }
  connectedCallback() {
    this.hasInitialView || ((this.view = n(this.getAttribute('data-default-view'))), (this.hasInitialView = !0)),
      this.updateButtons(),
      this.applyState(this.view),
      this.querySelectorAll('[data-view]').forEach((t) => {
        t.addEventListener('click', this.onButtonClick);
      }),
      (this.track = this.querySelector('.plp-image-toggle__track')),
      this.track && this.track.addEventListener('click', this.onTrackClick),
      document.addEventListener('plp:grid-rendered', this.onGridRendered);
  }
  disconnectedCallback() {
    this.querySelectorAll('[data-view]').forEach((t) => {
      t.removeEventListener('click', this.onButtonClick);
    }),
      this.track && (this.track.removeEventListener('click', this.onTrackClick), (this.track = null)),
      document.removeEventListener('plp:grid-rendered', this.onGridRendered);
  }
  onGridRendered() {
    this.applyState(this.view);
  }
  onTrackClick() {
    const t = this.view === a ? o : a;
    this.setView(t);
  }
  onButtonClick(t) {
    const i = t.currentTarget;
    if (!(i instanceof HTMLButtonElement)) return;
    const s = n(i.dataset.view);
    this.setView(s);
  }
  setView(t) {
    (this.view = n(t)), this.updateButtons(), this.applyState(this.view);
  }
  updateButtons() {
    this.setAttribute('data-current-view', this.view),
      this.querySelectorAll('[data-view]').forEach((t) => {
        if (!(t instanceof HTMLButtonElement)) return;
        const i = n(t.dataset.view) === this.view;
        t.classList.toggle('plp-image-toggle__btn--active', i), t.setAttribute('aria-pressed', String(i));
      });
  }
  applyState(t) {
    document.querySelectorAll(v).forEach((s) => {
      if (p(s.dataset.productType)) return;
      const e = s.querySelector(k);
      if (!(e instanceof HTMLImageElement)) return;
      const r = e.dataset.modelImage,
        c = e.dataset.clearcutImage;
      if (!r || !c || r === c) return;
      const l = Number.parseInt(e.dataset.modelWidth, 10),
        h = Number.parseInt(e.dataset.modelHeight, 10),
        u = Number.parseInt(e.dataset.clearcutWidth, 10),
        m = Number.parseInt(e.dataset.clearcutHeight, 10);
      g(e, r, c, l, t, h, u, m);
    }),
      document.dispatchEvent(new CustomEvent('plp:view-changed'));
  }
}
customElements.define('plp-image-toggle', E);
